module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"step1":"點擊右上角的…","step2":"選擇在瀏覽器中打開"},"en":{"step1":"Click on the \\"…\\" in the top-right corner","step2":"Open in Browser"},"ja":{"step1":"右上の「…」をクリック","step2":"「ブラウザで開く」をクリック"},"ko":{"step1":"오른쪽 상단 클릭….","step2":"웹 브라우저에서 열기"}}')
  delete Component.options._Ctor
}
